import { jsxs as m, jsx as r } from "@emotion/react/jsx-runtime";
import { EmptyStateContainer as p, EmptyImageContainer as E, EmptyStateContent as y, EmptyStateTitle as S, EmptyStateDescription as c, EmptyChildrenContainer as d } from "./EmptyState.styled.js";
import { SIZES_EMPTY_STATE as o } from "./EmptyState.types.js";
const v = ({
  size: t = "medium",
  title: a,
  description: e,
  image: n,
  children: i
}) => /* @__PURE__ */ m(p, { sizeEmptyState: t, children: [
  n && /* @__PURE__ */ r(E, { sizeEmptyState: t, children: n }),
  /* @__PURE__ */ m(y, { children: [
    a && /* @__PURE__ */ r(S, { variant: o[t].variantTitle, as: "p", children: a }),
    e && /* @__PURE__ */ r(c, { variant: o[t].variantDescription, as: "div", color: "secondary", children: e }),
    i && /* @__PURE__ */ r(d, { children: i })
  ] })
] });
export {
  v as EmptyState
};
